import React, { Component } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TagList from './TagList'; // adjust path if needed
import { APIData } from '../../constants/APIAdresses';

class TagDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tagInput: '',
            loading: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.fileItem?.id !== this.props.fileItem?.id || prevProps.open !== this.props.open) {
            this.setState({ tagInput: '' });
        }
    }

    handleAddTag = async () => {
        const { fileItem, onTagAdded } = this.props;
        const { tagInput } = this.state;

        if (!tagInput.trim()) return;

        this.setState({ loading: true });

        try {
            const res = await fetch(`${APIData.MEDIA}/file/${fileItem.id}/tags`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ tags: tagInput.trim() }),
                credentials: 'include' // include cookies for session management
            });

            if (res.ok) {
                onTagAdded(tagInput.trim()); // let parent add it to its state
                this.setState({ tagInput: '' });
            } else {
                console.error('Failed to add tag', await res.text());
            }
        } catch (err) {
            console.error('Error adding tag', err);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleAddTag();
        }
    };

    render() {
        const { open, onClose, fileItem, onDeleteTag, onAddFail, onTagAdded} = this.props;
        const { tagInput, loading } = this.state;

        if (!fileItem) return null;

        return (
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" style={{padding:0}}>
                <DialogTitle style={{fontSize: 16, wordBreak: 'break-word', whiteSpace:'normal'}}>
                    Tags Bearbeiten: {fileItem.filename}
                    <IconButton
                        onClick={onClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers  style={{paddingTop:0}}>
                    <div style={{ marginTop:16}}>
                        <TagList
                            onAddTag={(tag) => {
                                onTagAdded?.(tag);
                            }}
                            onAddFail={(tag) => {
                                console.error(`Failed to add tag!!??: "${tag}"`);
                                onAddFail?.(tag);
                            }}
                            key={fileItem.tags?.join('_') + fileItem.tags?.length}
                            fileItem={fileItem}
                            onDeleteTag={onDeleteTag}
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose} color="secondary">Close</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default TagDialog;

